import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry';

import { type NotificationCardConfig } from './notification-card.types';

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.html',
  imports: [Dynamic, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationCard {
  readonly config = input.required<NotificationCardConfig>();
  readonly disabled = input<boolean>(false);

  readonly action = output<DynamicAction>();

  protected readonly titleConfig = computed(() => ({
    text: this.config().title,
    fontWeight: 'semibold' as const,
    fontFamily: 'display' as const,
    color: 'var(--notification-card-title-color)',
  }));

  protected readonly supportingTextConfig = computed(() => ({
    text: this.config().supportingText ?? '',
    size: 'sm' as const,
    color: 'var(--notification-card-supporting-text-color)',
  }));

  protected onDismiss(): void {
    this.action.emit(this.config().dismissAction ?? { id: 'dismiss' });
  }

  protected onCardClick(): void {
    const action = this.config().action;
    if (action) {
      this.action.emit(action);
    }
  }
}
